/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reach_OutInputs */

const en_reach_out = /** @type {(inputs: Reach_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reach out`)
};

const es_reach_out = /** @type {(inputs: Reach_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contáctanos`)
};

const fr_reach_out = /** @type {(inputs: Reach_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prendre contact`)
};

const de_reach_out = /** @type {(inputs: Reach_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt aufnehmen`)
};

const ja_reach_out = /** @type {(inputs: Reach_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連絡する`)
};

const zh_reach_out = /** @type {(inputs: Reach_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系`)
};

const ar_reach_out = /** @type {(inputs: Reach_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تواصل معنا`)
};

const id_reach_out = /** @type {(inputs: Reach_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi kami`)
};

const it_reach_out = /** @type {(inputs: Reach_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contattaci`)
};

const ru_reach_out = /** @type {(inputs: Reach_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Связаться`)
};

const pt_reach_out = /** @type {(inputs: Reach_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre em Contato`)
};

const ko_reach_out = /** @type {(inputs: Reach_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문의하기`)
};

/**
* | output |
* | --- |
* | "Reach out" |
*
* @param {Reach_OutInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const reach_out = /** @type {((inputs?: Reach_OutInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reach_OutInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reach_out(inputs)
	if (locale === "es") return es_reach_out(inputs)
	if (locale === "fr") return fr_reach_out(inputs)
	if (locale === "de") return de_reach_out(inputs)
	if (locale === "ja") return ja_reach_out(inputs)
	if (locale === "zh") return zh_reach_out(inputs)
	if (locale === "ar") return ar_reach_out(inputs)
	if (locale === "id") return id_reach_out(inputs)
	if (locale === "it") return it_reach_out(inputs)
	if (locale === "ru") return ru_reach_out(inputs)
	if (locale === "pt") return pt_reach_out(inputs)
	return ko_reach_out(inputs)
});